$(() => {
  // console.log("starting event listeners for shogun...")
  $('[class*="download--"]').each((k,v) => {
    let downloadClass = Array.from(v.classList).find(each => each.slice(0,10) === 'download--');
    v.addEventListener('click', (e) => {
      let url = downloadClass.split('--')[1]
      fetch(url).then(function(response) {
        console.log('response', response)
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement('a');
        link.target="_blank"
        link.rel="noopener noreferrer"
        link.href = url;
        link.setAttribute('download', `Orbit.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => console.log(err));
    })
  })
  $('[class*="go-to--"]').each((k,v) => {
    $(v).click((e) => {
      e.preventDefault();
      let gotoClass = Array.from(e.currentTarget.classList).find(each => each.indexOf("go-to--") > -1)
      let gotoTargetClass = gotoClass.replace("go-to--", "");
      var offset = $("."+gotoTargetClass).offset();
      offset.left -= 50;
      offset.top -= 50;
      $('html, body').animate({
        scrollTop: offset.top,
        scrollLeft: offset.left
    });
      console.log('gotoTargetClass', gotoTargetClass);
    })
  })
})